import {
  BillingMode,
  ClassRecordKind,
  ClassRecordStatus,
  ClassType,
} from './types'

export const WEEKDAY_OPTIONS = [
  { label: '周一', value: 1 },
  { label: '周二', value: 2 },
  { label: '周三', value: 3 },
  { label: '周四', value: 4 },
  { label: '周五', value: 5 },
  { label: '周六', value: 6 },
  { label: '周日', value: 7 },
]

export const WEEKDAY_LABEL: Record<number, string> = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日',
}

export const CLASS_TYPE_OPTIONS = [
  { label: '认知课', value: ClassType.PERSONAL },
  { label: '言语纠音课', value: ClassType.SPEECH },
  { label: '感统课', value: ClassType.SENSORY },
  { label: '集体课', value: ClassType.GROUP },
]

export const CLASS_TYPE_LABEL: Record<ClassType, string> = {
  [ClassType.PERSONAL]: '认知课',
  [ClassType.SPEECH]: '言语纠音课',
  [ClassType.SENSORY]: '感统课',
  [ClassType.GROUP]: '集体课',
}

export const BILLING_MODE_OPTIONS = [
  { label: '按节收费', value: BillingMode.PER_CLASS },
  { label: '按月收费', value: BillingMode.MONTHLY },
  { label: '全天', value: BillingMode.ALL_DAY },
  { label: '赠课', value: BillingMode.GIFT },
]

export const DAILY_SEQUENCE_COLORS = [
  'geekblue',
  'cyan',
  'green',
  'gold',
  'volcano',
  'magenta',
  'purple',
]

export const DEFAULT_CLASS_DURATION_MINUTES = 40

export const CLASS_RECORD_KIND_OPTIONS = [
  { label: '正常记录', value: ClassRecordKind.MANUAL },
  { label: '补课消耗', value: ClassRecordKind.MAKEUP_USAGE },
]

export const CLASS_RECORD_KIND_LABEL: Record<ClassRecordKind, string> = {
  [ClassRecordKind.PLANNED]: '批量生成',
  [ClassRecordKind.MANUAL]: '手工补录',
  [ClassRecordKind.MAKEUP_USAGE]: '补课消耗',
}

export const CLASS_RECORD_STATUS_OPTIONS = [
  { label: '待上课', value: ClassRecordStatus.PENDING },
  { label: '已上课', value: ClassRecordStatus.ATTENDED },
  { label: '请假补课', value: ClassRecordStatus.LEAVE_MAKEUP },
  { label: '请假转金额', value: ClassRecordStatus.LEAVE_CONVERTED_TO_MONEY },
  { label: '转金额处理', value: ClassRecordStatus.CONVERTED_TO_MONEY },
]

export const CLASS_RECORD_STATUS_LABEL: Record<ClassRecordStatus, string> = {
  [ClassRecordStatus.PENDING]: '待上课',
  [ClassRecordStatus.ATTENDED]: '已上课',
  [ClassRecordStatus.LEAVE_MAKEUP]: '请假补课',
  [ClassRecordStatus.LEAVE_CONVERTED_TO_MONEY]: '请假转金额',
  [ClassRecordStatus.CONVERTED_TO_MONEY]: '转金额处理',
}
